import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { LoaderModule, PaginationIntergratedModule } from '@app/shared';
import { PipeModule } from '@app/shared';
import { FormsModule } from '@app/shared/forms';

import { LeaderboardComponent } from './leaderboard.component';
import { LeaderboardItemGoalComponent } from './item/goal/goal.component';
import { DataTestModule } from '@app/shared/directive/data-test';
import { IconComponent } from '@app/tw-shared/components';
import { LeaderboardItemComponent } from '../leaderboard-item/leaderboard-item.component';
import { PerfectScrollbarModule } from '@app/shared/perfect-scrollbar/perfect-scrollbar.module';
import { FormDropdownModule } from '@app/tw-shared/forms/form-dropdown/form-dropdown.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        NgbTooltipModule,
        TranslateModule,
        InlineSVGModule,
        LoaderModule,
        PaginationIntergratedModule,
        PipeModule,
        FormsModule,
        DataTestModule,
        PerfectScrollbarModule,
        IconComponent,
        LeaderboardItemComponent,
        FormDropdownModule,
    ],
    declarations: [LeaderboardComponent, LeaderboardItemGoalComponent],
    exports: [LeaderboardComponent],
})
export class LeaderboardModule {}
